import { useQuery } from "@tanstack/react-query";

import { requireData } from "../../shared/api/api-error.js";
import { useApi } from "../../shared/api/api-context.js";
import { tickerView } from "./models.js";

export const tickerKeys = { all: ["tickers"] as const };

export function useTickers() {
  const api = useApi();
  return useQuery({
    queryKey: tickerKeys.all,
    queryFn: async ({ signal }) => {
      const page = requireData(
        await api.GET("/tickers", { params: { query: { limit: 100 } }, signal }),
      );
      return page.items
        .map(tickerView)
        .sort((left, right) => left.symbol.localeCompare(right.symbol));
    },
    refetchInterval: 30_000,
  });
}
